import { FC } from 'react';

import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpText } from 'shared/ui/MpText';
import { UlStyled } from './PrinterDetails.styles';

export const PrinterDetails: FC = () => (
	<>
		<MpParagraph>
			Мобильное приложение поддерживает только 2 модели принтеров – Gprint 2120 с bluetooth и Zebra ZD420d.
		</MpParagraph>
		<MpText weight='bold'>Требования к оборудованию</MpText>
		<UlStyled>
			<li>
				{`Принтер термоэтикеток `}
				<a
					href='https://dodopizza.info/article/84c70564-3282-40f3-a417-684b78090351'
					target='_blank'
					rel='noreferrer'
				>
					Gprinter GP-2120TF
				</a>
				{` или Zebra`}
			</li>
			<li>Планшет или телефон на Android 5.0 и выше.</li>
			<li>
				Термоэтикетки:
				<UlStyled>
					<li>40 × 110 для вертикальных этикеток и широких этикеток с полным составом заказа</li>
					<li>40 х 56 для коротких этикеток с базовой информацией по продукту в заказе</li>
					<li>30 х 20 для этикеток с маркировкой сроков годности</li>
				</UlStyled>
			</li>
		</UlStyled>
	</>
);
